import { CreditPolicyResponseModel } from './../../../../models/response/credit-policy-response';
import { CustomerCreditStatusResponse } from './../../../../models/response/customer-credit-status-response';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-customer-credit-status',
  templateUrl: './customer-credit-status.component.html',
  styleUrls: ['./customer-credit-status.component.sass'],
})
export class CustomerCreditStatusComponent implements OnInit {
  public customerCreditStatus: CustomerCreditStatusResponse | undefined =
    undefined;

  @Input('customerCreditStatus') set changeCustomerCreditStatus(
    customerCreditStatus: CustomerCreditStatusResponse
  ) {
    this.customerCreditStatus = customerCreditStatus;
    this.percentageConsumedOnCreditLine = this.calcPercentageUsed('credit');
    this.percertageConsumenOnCreditCashLine = this.calcPercentageUsed('cash');
  }

  @Input() customerCreditPolicy: CreditPolicyResponseModel | undefined =
    undefined;

  public percentageConsumedOnCreditLine = 0;
  public percertageConsumenOnCreditCashLine = 0;

  constructor() {}

  ngOnInit(): void {}

  calcPercentageUsed(creditLineType: string): number {
    if (Object.keys(this.customerCreditStatus!).length > 0) {
      const creditLineTotal = Number(
        creditLineType === 'credit'
          ? this.customerCreditStatus!.informacionLineaCredito
              ?.montoLimiteCredito
          : this.customerCreditStatus!.informacionLineaEfectivo
              ?.montoLimiteEfectivo
      );

      const creditLineAvailable = Number(
        creditLineType === 'credit'
          ? this.customerCreditStatus!.informacionLineaCredito
              ?.montoDisponibleLimiteCredito
          : this.customerCreditStatus!.informacionLineaEfectivo
              ?.montoDisponibleLimiteEfectivo
      );

      const percentageAvailable = Number(
        creditLineType === 'credit'
          ? this.getNumericValue(this.customerCreditStatus!.informacionLineaCredito
              ?.pctDisponibleLimiteCredito)
          : this.getNumericValue(this.customerCreditStatus!.informacionLineaEfectivo
              ?.pctDisponibleLimiteEfectivo)
      );

      if (creditLineTotal <= 0 || percentageAvailable == 1) {
        return 0;
      }

      return (100 * Math.round((1 - percentageAvailable) * 100)) / 100;
    }
    return 0;
  }

  getNumericValue(val: string | undefined ): number {
    return isNaN(Number(val!)) ? Number(val!.replace('-', '')) * -1 : Number(val!);
  }
}
